import {Fragment} from 'react';

import List from './List';

const Messages = ({metars, tafs}) => {
    const [first, ...extended] = metars;
    const always = [...tafs, first];

    return (
        <Fragment>
            <List className="always" messages={always} />
            <List className="extended" messages={extended} />
        </Fragment>
    );
};

export default Messages;
